import React, { useState } from 'react'
import { TouchableOpacity, View } from 'react-native'
import DatePicker from 'react-native-date-picker'
import { Controller, FieldValues, Control, FieldPath } from 'react-hook-form'
import { TextInput } from '../molecules/TextInput'
import dayjs from 'dayjs'
import { getCommonStyles } from '@utils'
import { useTheme } from '@react-navigation/native'
import { Text } from '../atoms'
import { useScreen } from '@hooks'
import { useLanguage } from '@context'

type FormDateProps<TFieldValues extends FieldValues> = {
  control: Control<TFieldValues>
  name: FieldPath<TFieldValues>
  title?: string
  icon?: string
  iconLeft?: string
  placeholder?: string,
  dateFormat?: string,
  value?: string,
  onChange?: (date: string) => void
  hourValue?: string,
  onDatePressed?: () => void
  onHourPressed?: () => void
  hasError?: boolean
}

export const FormDate = <TFieldValues extends FieldValues>({
  control,
  name,
  title,
  icon,
  iconLeft,
  placeholder,
  dateFormat,
  value: valueProp,
  onChange: onChangeProp,
  hourValue,
  onDatePressed,
  onHourPressed,
  hasError,
}: FormDateProps<TFieldValues>) => {
  const theme = useTheme()
  const { t } = useLanguage()
  const {isWeb} = useScreen()
  const commonStyles = getCommonStyles(theme)
  const [date, setDate] = useState(new Date())
  const [time, setTime] = useState(hourValue || dayjs().format('HH:mm'))
  const [timePickerVisible, setTimePickerVisible] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  return (
    <>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <View style={commonStyles.flex}>
            <DatePicker
              modal
              mode="date"
              /* TODO: remove the hour(8) */
              date={valueProp ? dayjs(valueProp, 'DD-MM-YYYY').hour(8).toDate() : date}
              open={isOpen}
              onConfirm={(selectedDate) => {
                const dateString = selectedDate.toLocaleDateString('fr-FR')

                setDate(selectedDate)
                setIsOpen(false)
                onChange(dateString)
                onChangeProp && onChangeProp(dateString)
              }}
              onCancel={() => setIsOpen(false)}
            />
            {!!title && <Text type='bodySmall' color={theme.colors.greyBlue}>{title}</Text>}
            <View style={{marginTop: !!title? theme.spacing.md : 0, flex: 1, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', borderColor: (!!error || hasError) ? theme.colors.error : theme.colors.lightGrey, borderWidth: 1, borderRadius: theme.spacing.xxxl}}>
              <TouchableOpacity onPress={() => {
                if(!!onDatePressed) 
                  onDatePressed?.()
                else setIsOpen(true)
              }} style={commonStyles.flex}>
                <TextInput
                  iconLeft={iconLeft as any}
                  iconRight={icon as any}
                  value={valueProp ? dayjs(valueProp, 'DD-MM-YYYY').format(dateFormat || 'DD-MM-YYYY') : value || ''}
                  //errorMessage={error?.message}
                  editable={false}
                  pointerEvents="none"
                  placeholder={placeholder}
                  noBorder
                />
              </TouchableOpacity>
              {!!onHourPressed && 
                <TouchableOpacity onPress={() => {
                  if(isWeb){
                    onHourPressed()
                  } else {
                    setTimePickerVisible(true)
                  }
                }}>
                  <TextInput
                    //containerStyle={styles.textInputContainer}
                    //style={styles.blackTextInput}
                    placeholder={t('formExtra.selectTime')}
                    value={hourValue}
                    editable={false}
                    pointerEvents='none'
                    noBorder
                    contentStyle={{width: 100}}
                  />
                </TouchableOpacity>
              }
            </View>
          </View>
        )}
      />
      <DatePicker
        modal
        date={time ? dayjs(time, 'HH:mm').toDate() : new Date()}
        onDateChange={setDate}
        mode="time"
        open={timePickerVisible}
        onConfirm={(time) => {
          setTime(time.getHours().toString().padStart(2, '0') + ':' + time.getMinutes().toString().padStart(2, '0'))
          onChangeProp && onChangeProp(dayjs(date.toISOString()).hour(time.getHours()).minute(time.getMinutes()).toISOString())
          setTimePickerVisible(false)
        }}
        onCancel={() => setTimePickerVisible(false)}
      />
    </>
  )
}